import { __awaiter } from "tslib";
import React, { useState, useEffect } from 'react';
import { calcClock } from '@ligr/api-v2';
import { getCurrentPeriod } from '../summary/getCurrentPeriod';
import { pause } from './util/pause';
export const useClock = (match, summary, skewMsAdjustment = 0) => {
    const [recheckId, setRecheckId] = useState(1);
    const isSubscribed = React.useRef(true);
    // defines the clock in the live period.
    const [clockData, setClockData] = useState();
    const currentPeriod = getCurrentPeriod(summary);
    function checkClock() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!summary || !currentPeriod)
                return undefined;
            const newClockData = calcClock(match.date, match.sport.name, summary.clock, summary.periods, summary.currentPeriod, match.config, skewMsAdjustment);
            if (currentPeriod.status === 'live') {
                if (!clockData ||
                    clockData.clock !== newClockData.clock ||
                    clockData.injuryClock !== newClockData.injuryTimeClock) {
                    setClockData({
                        clock: newClockData.clock,
                        running: newClockData.running,
                        secondsSinceStart: newClockData.secondsSinceStart,
                        injuryClock: newClockData.injuryTimeClock
                    });
                }
            }
            else if (currentPeriod.status === 'break') {
                if (!clockData || clockData.countdownClock !== newClockData.countdownClock) {
                    setClockData({
                        countdown: newClockData.countdown,
                        countdownClock: newClockData.countdownClock,
                        expectedSecondsTillStart: newClockData.expectedSecondsTillStart,
                        secondsSinceStart: newClockData.secondsSinceStart
                    });
                }
            }
            yield pause(newClockData.tillNextTick || 500);
            if (isSubscribed.current) {
                setRecheckId(recheckId + 1);
            }
        });
    }
    useEffect(() => {
        isSubscribed.current = true;
        if (isSubscribed.current) {
            checkClock();
        }
        return () => {
            isSubscribed.current = false;
        };
    }, [recheckId]);
    return clockData;
};
//# sourceMappingURL=useClock.js.map